import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const addMeetupAgenda = createAsyncThunk(
  "addMeetupAgenda",
  async ({ meetupId, agendaData }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.post(`meetup/${meetupId}/agenda`, agendaData);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteMeetupAgenda = createAsyncThunk(
  "deleteMeetupAgenda",
  async (agendaId, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.delete(`meetup/agenda/${agendaId}`);
      return { agendaId, ...response.data };
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const MeetupAgendaSlice = createSlice({
  name: "MeetupAgendaSlice",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetAgendaState: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addMeetupAgenda.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(addMeetupAgenda.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(addMeetupAgenda.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteMeetupAgenda.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteMeetupAgenda.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(deleteMeetupAgenda.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetAgendaState } = MeetupAgendaSlice.actions;
export default MeetupAgendaSlice.reducer;
